import type { BaseRequestFailureActionCreator } from "types";
import type { WizardActionPayload } from "types/unifiedWizard";

export const GET_STARTED_ACTION_REQUEST = "GET_STARTED_ACTION_REQUEST";
export const GET_STARTED_ACTION_REQUEST_SUCCESS = "GET_STARTED_ACTION_REQUEST_SUCCESS";
export const GET_STARTED_ACTION_REQUEST_FAILURE = "GET_STARTED_ACTION_REQUEST_FAILURE";

export const request = (
  payload: WizardActionPayload,
  resolve?: () => void,
  reject?: (e: Error) => void
) => ({
  type: GET_STARTED_ACTION_REQUEST,
  payload,
  resolve,
  reject,
});

export const requestSuccess = () => ({
  type: GET_STARTED_ACTION_REQUEST_SUCCESS,
});

export const requestFailure: BaseRequestFailureActionCreator = (error) => ({
  type: GET_STARTED_ACTION_REQUEST_FAILURE,
  error,
});
